import React from 'react';
import { s as styles } from '../audio.rtlignore-fad433f7.js';
import { AUDIO_TITLE, AUDIO_CREATOR } from '../dataHooks.js';
import '../style-inject.es-e7b07dd7.js';

const AudioDetails = ({ authorName, title }) => {
  return /* @__PURE__ */ React.createElement("div", { className: styles.audioDetails }, title && /* @__PURE__ */ React.createElement("span", { className: styles.title, "data-hook": AUDIO_TITLE }, title), authorName && /* @__PURE__ */ React.createElement("span", { className: styles.author_name, "data-hook": AUDIO_CREATOR }, authorName));
};

export { AudioDetails as default };
//# sourceMappingURL=AudioDetails.js.map
